/** Channels — multichannel scaffold (Phase B1 MVP). */

import { ArrowLeft, Building2 } from "lucide-react";
import { Link } from "react-router-dom";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function ChannelsPage(): JSX.Element {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <Button asChild variant="ghost" size="sm">
          <Link to="/configuration">
            <ArrowLeft className="w-4 h-4 mr-1" />
            Конфигурация
          </Link>
        </Button>
      </div>
      <div>
        <h1 className="text-2xl font-heading flex items-center gap-2">
          <Building2 className="w-6 h-6" />
          Каналы продаж
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          Multichannel-инфраструктура заложена. UI для управления каналами
          подключим когда понадобится второй канал (B2B / Uzum / Yandex).
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Активные каналы</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-between p-3 rounded-md bg-muted/30">
            <div>
              <div className="font-medium">Розница (default)</div>
              <div className="text-xs text-muted-foreground mt-0.5">
                slug=retail · currency=UZS · country=UZ
              </div>
            </div>
            <Badge variant="secondary">default</Badge>
          </div>
          <p className="text-xs text-muted-foreground mt-4">
            Все existing products и orders уже привязаны к этому каналу
            (channel_id заполнен миграцией 027). Добавление новых каналов
            появится в админке в следующей итерации.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
